export const getSetupId = (setup) => setup?.id ?? setup?.Id;

export const getSetupIsDefault = (setup) =>
  Boolean(setup?.isDefault ?? setup?.IsDefault ?? false);

/**
 * Dropdown label: ProviderType - ModelName (IdentityName)
 */
export const getModelSetupLabel = (setup) => {
  const provider =
    setup?.providerType ||
    setup?.ProviderType ||
    setup?.model?.providerType ||
    setup?.Model?.ProviderType ||
    "AI";
  const modelName =
    setup?.modelName ||
    setup?.ModelName ||
    setup?.model?.modelName ||
    setup?.Model?.ModelName ||
    "Model";
  const identity =
    setup?.identityName || setup?.IdentityName || "Setup";
  return `${provider} - ${modelName} (${identity})`;
};

export const findDefaultSetupId = (setups) => {
  const list = Array.isArray(setups) ? setups : [];
  const defaultSetup = list.find((s) => getSetupIsDefault(s));
  const pick = defaultSetup || list[0];
  return pick ? String(getSetupId(pick)) : "";
};

/**
 * Fallback: response key → camelCase form key when not in explicit fieldMap.
 */
export const normalizeFieldKey = (key) => {
  if (!key || typeof key !== "string") return "";
  const trimmed = key.trim();
  if (!trimmed.includes("_") && !trimmed.includes("-")) {
    return trimmed.charAt(0).toLowerCase() + trimmed.slice(1);
  }
  return trimmed
    .replace(/[-_](.)/g, (_, c) => c.toUpperCase())
    .replace(/^./, (c) => c.toLowerCase());
};
